import { NgModule } from '@angular/core';

import { InputTagComponent } from './components/input-tag.component';

@NgModule({
    declarations: [
        InputTagComponent,
    ],
    providers: [
        {
            provide: 'window',
            useValue: window,
        },
    ],
    exports: [
        InputTagComponent,
    ],
})

export class InputTagModule {}
